/* Evermont — scripts propios (vanilla, sin librerías) */
(function () {
  'use strict';
  if (window.__dmLoaded) return;
  window.__dmLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.dm-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (e) { e.classList.add('dm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('dm-visible');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery() {
    document.querySelectorAll('[data-dm-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-dm-main]');
      var thumbs = g.querySelectorAll('[data-dm-thumb]');
      var box = g.querySelector('.dm-gallery__main');
      var gv = g.querySelector('[data-dm-gvideo]');
      var gvEl = gv && gv.querySelector('video');
      if (!thumbs.length) return;
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.hasAttribute('data-video')) {
            if (box) box.classList.add('dm-gallery__main--video');
            if (gvEl) { var p = gvEl.play(); if (p && p.catch) p.catch(function () {}); }
          } else {
            if (box) box.classList.remove('dm-gallery__main--video');
            if (gvEl) gvEl.pause();
            if (main) {
              main.removeAttribute('srcset');
              main.src = b.getAttribute('data-src');
              main.alt = b.getAttribute('data-alt') || '';
            }
          }
          thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
          b.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------- Caja de compra: precio y estado según el pack elegido ---------- */
  function initBuy() {
    document.querySelectorAll('[data-dm-buy]').forEach(function (box) {
      var price = box.querySelector('[data-dm-price]');
      var compare = box.querySelector('[data-dm-compare]');
      var save = box.querySelector('[data-dm-save]');
      var btn = box.querySelector('[data-dm-submit]');
      var form = box.querySelector('form');
      var radios = box.querySelectorAll('input[type="radio"][name="id"]');

      function apply(r) {
        if (price) price.textContent = r.getAttribute('data-price');
        var c = r.getAttribute('data-compare');
        var s = r.getAttribute('data-save');
        if (compare) { compare.textContent = c || ''; compare.hidden = !c; }
        if (save) { save.textContent = s || ''; save.hidden = !s; }
        if (btn) {
          var ok = r.getAttribute('data-available') === 'true';
          btn.disabled = !ok;
          btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
        }
      }

      radios.forEach(function (r) { r.addEventListener('change', function () { apply(r); }); });
      var checked = box.querySelector('input[type="radio"][name="id"]:checked');
      if (checked) apply(checked);

      if (form && btn) {
        form.addEventListener('submit', function () {
          btn.textContent = 'Añadiendo…';
          btn.style.pointerEvents = 'none';
        });
      }
    });
  }

  /* ---------- Aviso «alguien acaba de comprar» ---------- */
  function initToast() {
    var toast = document.querySelector('[data-dm-toast]');
    if (!toast) return;
    try { if (sessionStorage.getItem('dm-toast-off') === '1') return; } catch (e) {}

    function lines(raw) {
      return (raw || '').split(/<br\s*\/?>|\n/i).map(function (s) { return s.trim(); }).filter(Boolean);
    }
    var people = lines(toast.getAttribute('data-people')).map(function (l) {
      var p = l.split('|');
      return { name: (p[0] || '').trim(), city: (p[1] || '').trim() };
    }).filter(function (p) { return p.name; });
    var times = lines(toast.getAttribute('data-times'));
    if (!people.length) return;
    if (!times.length) times = ['hace un momento'];

    var first = (parseFloat(toast.getAttribute('data-first')) || 8) * 1000;
    var show = (parseFloat(toast.getAttribute('data-show')) || 6) * 1000;
    var gap = (parseFloat(toast.getAttribute('data-gap')) || 14) * 1000;
    var prefix = toast.getAttribute('data-action') || 'acaba de comprar';
    var of = toast.getAttribute('data-of') || 'de';

    var elWho = toast.querySelector('[data-dm-who]');
    var elWhat = toast.querySelector('[data-dm-what]');
    var elWhen = toast.querySelector('[data-dm-when]');
    var closeBtn = toast.querySelector('[data-dm-close]');
    var last = -1;
    var stopped = false;
    var timer;

    function pick(list) {
      var i;
      do { i = Math.floor(Math.random() * list.length); } while (list.length > 1 && i === last);
      last = i;
      return i;
    }

    function cycle() {
      if (stopped) return;
      if (document.hidden) { timer = setTimeout(cycle, 4000); return; }
      var p = people[pick(people)];
      elWho.innerHTML = '';
      var strong = document.createElement('strong');
      strong.textContent = p.name;
      elWho.appendChild(strong);
      elWho.appendChild(document.createTextNode((p.city ? ' ' + of + ' ' + p.city + ' ' : ' ') + prefix));
      elWhen.textContent = times[Math.floor(Math.random() * times.length)];
      toast.classList.add('dm-toast--on');
      timer = setTimeout(function () {
        toast.classList.remove('dm-toast--on');
        timer = setTimeout(cycle, gap);
      }, show);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        stopped = true;
        clearTimeout(timer);
        toast.classList.remove('dm-toast--on');
        try { sessionStorage.setItem('dm-toast-off', '1'); } catch (e) {}
      });
    }
    timer = setTimeout(cycle, first);
  }


  /* ---------- Vídeo del producto: reproducir al verse, sonido opcional ---------- */
  function initVideo() {
    document.querySelectorAll('[data-dm-videowrap]').forEach(function (wrap) {
      var v = wrap.querySelector('video');
      if (!v) return;
      var btn = wrap.querySelector('[data-dm-sound]');
      var label = btn && btn.querySelector('[data-dm-sound-label]');
      v.muted = true;
      v.loop = true;
      v.setAttribute('playsinline', '');
      if (btn) {
        btn.addEventListener('click', function () {
          v.muted = !v.muted;
          if (!v.muted) { v.volume = 1; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          btn.setAttribute('aria-pressed', String(!v.muted));
          if (label) label.textContent = v.muted ? 'Activar sonido' : 'Silenciar';
          wrap.classList.toggle('dm-vid--sound', !v.muted);
        });
      }
      if (reduceMotion) {
        v.removeAttribute('autoplay');
        v.pause();
        v.controls = true;
        if (btn) btn.style.display = 'none';
        return;
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var hiddenInGallery = wrap.hasAttribute('data-dm-gvideo') && !wrap.parentNode.classList.contains('dm-gallery__main--video');
            if (e.isIntersecting && !hiddenInGallery) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else { v.pause(); }
          });
        }, { threshold: 0.25 });
        io.observe(wrap);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initGallery();
    initBuy();
    initToast();
    initVideo();
  });
})();
